var absoluteUrlRegex = new RegExp('^(?:[a-z]+:)?//', 'i');
var isExternalLink = function isExternalLink(linkUrl) {
  return linkUrl && linkUrl !== null && absoluteUrlRegex.test(linkUrl);
};
export default isExternalLink;